const formats = [
  {
    image: '/images/smartTvAdvertising/formats/preroll-skip.svg',
    prefix: 'preroll/midroll ',
    highlight: 'skippable',
    suffix: ' ads',
    time: '7-15 վ',
  },
  {
    image: '/images/smartTvAdvertising/formats/preroll-timer.svg',
    prefix: 'preroll/midroll ',
    highlight: 'non-skippable',
    suffix: ' ads',
    time: '15-20 վ',
  },
  {
    image: '/images/smartTvAdvertising/formats/qr-code.svg',
    prefix: 'video ads with ',
    highlight: 'QR integration',
    suffix: '',
    time: '15-20 վ',
  },
];

const AdFormats = () => {
  return (
    <div className="bg-[#000000]">
      <div className="container py-[48px] md:py-[80px]">
        <h2 className="text-center font-[500] text-[28px] md:text-[36px] text-white mb-[32px] md:mb-[48px]">Գովազդային ֆորմատներ</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-[24px]">
          {formats.map((item, i) => (
            <div key={i} className="group bg-[#242820] rounded-[24px] p-[24px] flex flex-col gap-[16px] max-w-[400px] mx-auto overflow-visible transition-colors duration-300 hover:bg-[#333a2a]">
              <div className="flex flex-col gap-[16px] transition-transform duration-300 group-hover:scale-[1.1]">
                <div className="w-full bg-white rounded-[10px] p-[12px]">
                  <img src={item.image} alt="" className="object-cover w-full" />
                </div>
                <div>
                  <p className="text-white text-[16px] font-[700]">
                    {item.prefix}
                    <span className="text-[#9ebf91]">{item.highlight}</span>
                    {item.suffix}
                  </p>
                  <p className="text-[#9ebf91] text-[16px] font-[700] mt-[8px]">{item.time}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdFormats;
